import { NumericInput } from "component/inputs/NumericInput";
import { SlotsConstants } from "constants/slots";
import { Field } from "react-final-form";
import "./FrequencyComponent.scss";
import { FrequencyComponentType } from "./types";
import "./i18n";
import { useTranslation } from "react-i18next";

const FrequencyComponent = ({
  name,
  disabledDays = [],
  testId,
}: FrequencyComponentType) => {
  const { t } = useTranslation();
  return (
    <div className="frequency-container">
      <div className="container-frequency">
        <div className="container-frequency-row">
          <div className="container-frequency-col-xs-1 flex">
            <p
              className="day-label title"
              data-testid={`${testId}-frequency-title`}
            >
              {t("frequency:frequency")}
            </p>
            <p
              className="day-label title"
              data-testid={`${testId}-capacity-title`}
            >
              {t("frequency:capacity")}
            </p>
          </div>
          {SlotsConstants.FULL_WEEK_DAYS.map((day) => (
            <div key={day.id} className="container-frequency-col-xs-1 flex">
              <p
                className={`day-label ${
                  disabledDays.includes(day.id) ? "disabled" : ""
                }`}
                data-testid={`${testId}-${day.id}-label`}
              >
                {t(`global:${day.name}`)}
              </p>
              <Field
                type="text"
                name={`${name}.${day.id}`}
                component={NumericInput}
                allowDecimal={false}
                maxInt={4}
                className="Admin-Pickers-input frequency-input"
                placeholder={t(
                  `${
                    disabledDays.includes(day.id)
                      ? "-"
                      : t("frequency:enterNumber")
                  }`
                )}
                disabled={disabledDays.includes(day.id)}
                testId={`${testId}-${day.id}-capacity`}
                id={`${testId}-${day.id}-capacity`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FrequencyComponent;
